<script setup>
import {ref} from "vue";
import TrackerPermissionsModal from "@/components/trackers/TrackerPermissionsModal.vue";
import trackersService from "@/services/trackers.service";

const emit = defineEmits(['saved']);
const {trackerId} = defineProps(['trackerId']);
const trackerPermissionsModal = ref(null);

async function getPermissions() {
    const {data} = await trackersService.getPermissions(trackerId);
    trackerPermissionsModal.value.open(data);
}

async function savePermissions(permissions) {
    await trackersService.savePermissions(trackerId, permissions);
    emit('saved');
}

function open() {
    getPermissions();
}

defineExpose({
    open
});
</script>

<template>
    <TrackerPermissionsModal
        ref="trackerPermissionsModal"
        @save="savePermissions"
    />
</template>

<style scoped>

</style>
